module.exports = __webpack_public_path__ + "img/s2_t1_02.749edfd3.jpeg";